<template>
  <div class="flex flex-col overflow-y-auto h-full pb-10">
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <template v-else>
      <div class="grid  grid-cols-4 md:grid-cols-8 lg:grid-cols-12 gap-4">
        <div class="col-span-4">
          <div class="flex flex-col" id="selection">
            <button
              class="warning-button ml-auto mr-4"
              @click="updateSyncCountries()"
              v-if="!loading"
            >
              Sync Countries
            </button>
            <div
              class="
                flex
                flex-row
                justify-center
                items-center
                bg-white
                border
                border-gray-300
                p-2
                text-center
                m-2
                rounded-md
                hover:bg-gray-300
                hover:text-white
                w-72
              "
              v-if="selectedCountry !== ''"
            >
              {{ selectedCountry }} - {{ selectedCountryCode }}
              <button
                @click="selectedCountry = ''"
                class="bg-black rounded-full overflow-hidden text-white w-6 h-6 ml-4 flex justify-center items-center font-bold"
              >
                x
              </button>
            </div>
          </div>
          <div id="countries" class="w-72 p-4" v-if="selectedCountry == ''">
            <h1>Country Name</h1>
            <input
              class="border border-gray-300 rounded-md w-full p-2 mb-4"
              placeholder="filter country"
              v-model="countrySearch"
            />
            <div
              class="
                w-full
                bg-white
                border
                border-gray-300
                p-2
                text-center
                rounded-md
                my-2
                hover:bg-gray-300
                hover:text-white
              "
              v-for="country in filteredCountries"
              :key="country.id"
              @click="selectCountry(country.countryName, country.localCode)"
            >
              <h1>{{ country.countryName + " - " + country.localCode }}</h1>
            </div>
          </div>
        </div>
        <div class="col-span-4">
          <States
            @selectedState="selectState"
            @deselectedState="selectedState = ''"
            v-if="selectedCountry !== ''"
            :country="selectedCountry"
          ></States>
        </div>
        <div class="col-span-4">
          <Cities
            @selectedCity="selectCity"
            v-if="selectedCountry !== '' && selectedState !== ''"
            :country="selectedCountry"
            :state="selectedState"
          ></Cities>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { getCountries, getSyncCountries } from "@/api/Infoauto.js";
import States from "@/components/infoauto/States.vue";
import Cities from "@/components/infoauto/Cities.vue";

export default {
  name: "Address",
  components: {
    States,
    Cities
  },
  data() {
    return {
      countries: [],
      loading: true,
      countrySearch: "",
      selectedCountry: "",
      selectedCountryCode: "",
      selectedState: "",
      selectedCity: ""
    };
  },
  async mounted() {
    try {
      this.countries = await getCountries();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  computed: {
    filteredCountries() {
      return this.countries.filter(country => {
        return country.countryName
          .toLowerCase()
          .includes(this.countrySearch.toLowerCase());
      });
    }
  },
  methods: {
    selectState(state) {
      console.log("from address:", state);
      this.selectedState = state;
    },
    selectCity(city) {
      console.log("from address:", city);
      this.selectedCity = city;
    },
    async updateSyncCountries() {
      this.loading = true;
      try {
        this.countries = await getSyncCountries();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    async selectCountry(countryName, countryCode) {
      this.selectedCountry = countryName;
      this.selectedCountryCode = countryCode;
    }
  }
};
</script>
